import { SxProps } from '@mui/material';

export const inputStyle: SxProps = {
  textTransform: 'uppercase',

  '::placeholder': {
    textTransform: 'none',
  },
};
